import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { CoachInfo } from './types';

export interface CoachesState {
  selectedCoach: CoachInfo | null;
}

const initialState: CoachesState = {
  selectedCoach: null
};

const coachesSlice = createSlice({
  name: 'coaches',
  initialState,
  reducers: {
    changeActiveCoach: (state, action: PayloadAction<CoachInfo | null>) => {
      state.selectedCoach = action.payload;
    },
  }
});

export const selectActiveCoach = (state: RootState) => state.coaches.selectedCoach;

export const { changeActiveCoach } = coachesSlice.actions;
export { coachesSlice };
